<template>
  <div class="container">
    <!-- 导航栏 -->
    <!-- <div class="contNav">
      <div class="navList">
        <div
          v-for="(item, i) in navList"
          :key="i"
          :class="{ checked: checkedNav === i }"
          @click="navFn(i)"
        >
          {{ item }}
        </div>
        <span>|</span>
      </div>
    </div> -->
    <!-- 左图表 -->
    <div class="left" v-show="chartListShow">
      <img src="https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/textures/left.png" />
      <chart-list
        class="leftChartList"
        :chartListData="chartList1"
      ></chart-list>
    </div>

    <!-- 右图表 -->
    <div class="right" v-show="chartListShow">
      <img src="https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/textures/right.png" />
      <chart-list
        class="rightChartList"
        :chartListData="chartList2"
      ></chart-list>
    </div>
    <div class="machineList">
      <div class="macineBox">
        <div
          v-for="(item, i) in machineList"
          :key="i"
          :class="{ checkedTab: checkedTab === i }"
          @click="checkedTabFn(i)"
        >
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chartList from "@/components/home_echarts/chartList.vue";
import { getCurrentTime } from "@/assets/js/getCurrentTime";
export default {
  components: {
    chartList,
  },
  data() {
    return {
      currentTime: {}, //当前时间
      navList: ["Home", "DataAnalysis"],
      checkedNav: 0, // 选中nav
      chartList1: [
        {
          id: "chart1",
          headName: "",
          type: 0,
        },
        {
          id: "chart2",
          headName: "",
          type: 0,
        },
        {
          id: "chart3",
          headName: "",
          type: 0,
        },
      ],
      // 右边图表数据
      chartList2: [
        {
          id: "chart4",
          headName: "",
          type: 1,
        },
        {
          id: "chart5",
          headName: "",
          type: 1,
        },
        {
          id: "chart6",
          headName: "",
          type: 1,
        },
      ],
      chartListShow: true,
      // 机器按钮列表
      machineList: [
        "SMT-A",
        "BatteryA",
        "BatteryB",
        "Home",
        "BatteryC",
        "BatteryD",
        "SMT-B",
      ],
      checkedTab: 3, // 选择机器
    };
  },
  created() {
    //获取时间
    this.timer = setInterval(() => {
      this.currentTime = getCurrentTime();
    }, 1000);
  },
  mounted() {},
  methods: {
    navFn(flag) {
      if (flag == 1) {
        this.chartListShow = true;
      } else {
        this.chartListShow = false;
      }
      this.checkedNav = flag;
      this.$emit("transfer", this.checkedNav);
    },
    checkedTabFn(i) {
      if (i == 3) {
        this.chartListShow = true;
      } else{
        this.chartListShow = false;
      }
      this.checkedTab = i;
      this.$emit("modelButton", this.checkedTab);
    },
     addWaterMarker() {
      let img = new Image();
      img.setAttribute("crossOrigin", 'Anonymous');
      img.src = "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/images/waterMark.png";
      //img.src = "/img/waterMark.png";
      var can = document.createElement('canvas');
      var watermark = document.getElementById('watermark');

      watermark.appendChild(can);
      can.width = 376; //画布的宽
      can.height = 282;//画布的高度
      can.style.display = 'none';
      var cans = can.getContext('2d');
      img.onload = () => {
        cans.drawImage(img, 50, 0, 180, 140);
        watermark.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")"; //把画布插入到body中
        watermark.style.opacity = 0.3;
      }
    }
  },
  destroyed() {
    // 页面销毁前清除定时器
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  .left {
    position: fixed;
    width: 372px;
    height: calc(100% - -26px);
    top: 62px;
    img {
      width: 372;
      height: calc(100% - 130px);
    }
  }
  .right {
    position: fixed;
    width: 372px;
    height: calc(100% - -26px);
    top: 59px;
    right: -76px;
    img {
      width: 372;
      height: calc(100% - 130px);
    }
  }
  .leftChartList {
    width: 302px;
    height: calc(100% - 130px);
    position: fixed;
    top: 69px;
  }
  .rightChartList {
    width: 302px;
    height: calc(100% - 130px);
    position: fixed;
    top: 69px;
  }
  display: flex;
}
.contNav {
  width: calc(100% - 66px);
  height: 50px;
  padding: 0 40px;
  position: fixed;
  top: 50px;
  left: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.navList {
  display: flex;
  div {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #fff;
    padding: 5px 20px;
    border: 1px solid transparent;
    cursor: pointer;
  }
  span {
    padding: 8px 20px;
    color: #fff;
    text-align: center;
    position: fixed;
    left: 142px;
    font-size: 20px;
  }

  .checked {
    // background: #325988;
    color: #00ffff;
    // border: 1px solid #394051;
    // border-radius: 30px;
  }
}

@font-face {
  font-family: Arboria;
  src: url("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/Fonts/Arboria-Medium.otf");
}
.time {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  z-index: 9;
  cursor: default;

  .nowDate {
    font-size: 27px;
    font-family: Arboria;
    color: #00ccff;
    white-space: nowrap;
    font-weight: 900;
  }

  .nowTime {
    height: 25px;
    margin-left: 12px;
    font-size: 27px;
    font-weight: 600;
    font-family: Arboria;
    line-height: 25px;
    color: #00ccff;
    white-space: nowrap;
  }
}

.machineList {
  width: calc(100% - 207px);
  height: 59px;
  position: fixed;
  bottom: 1px;
  left: 117px;
  background: url("../assets/images/bottom.png") center no-repeat;
  background-size: 120% 120%;
  .macineBox {
    width: calc(100% - 207px);
    height: 59px;
    position: fixed;
    bottom: 1px;
    left: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div {
    width: 6%;
    height: 34px;
    margin-left: 31px;
    margin-top: 19px;
    text-align: center;
    line-height: 32px;
    font-size: 19px;
    font-family: Arboria;
    color: #fff;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .checkedTab {
    color: #00ffff;
  }
}
</style>